import dynamic from 'next/dynamic';
import LoaderPage from '@/reactPages/LoaderPage/LoaderPage';

export const Contacts = dynamic(() => import('./Contacts'), {
  ssr: false,
  loading: () => <LoaderPage/>,
});
